var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderDetailsRightarrowC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#DAE1EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 16.3333C10.5001 16.3333 14.6667 13.2647 14.6667 12.1667C14.6667 11.0687 10.5 8 10.5 8",
    stroke: "#2C3A4B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDetailsRightarrowC);
export default __webpack_public_path__ + "static/media/order-details-rightarrowC.88c9c43061f1cd22570b2e3727d80608.svg";
export { ForwardRef as ReactComponent };